import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        popover: {
            placement: 'top',
            arrowShadowColor: `0 0 ${remCalc(6)} 0 rgba(0, 0, 0, 0.15)`,
            arrowPadding: 309,
            offset: [-153, 15],
        },
        container: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            gap: remCalc(8),
            backgroundColor: 'background.default',
            boxShadow: `0 0 ${remCalc(6)} 0 rgba(0, 0, 0, 0.15) !important`,
            transition: 'box-shadow 0.3s ease',
            borderRadius: 0,
            border: 'none',
            width: remCalc(256),
            marginBottom: remCalc(9),
        },
        arrow: {
            boxShadow: 'none',
            width: `${remCalc(10)} !important`,
            height: `${remCalc(10)} !important`,
        },
        body: {
            display: 'flex',
            padding: remCalc(16),
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: remCalc(10),
            alignSelf: 'stretch',
        },
        hstack: {
            display: 'flex',
            alignItems: 'flex-start',
            gap: remCalc(16),
            alignSelf: 'stretch',
        },
        title: {
            textStyle: 'body-xsmall',
            color: 'text.default',
            fontWeight: 700,
        },
        description: {
            textStyle: 'body-xsmall',
            color: 'text.default',
            fontWeight: 400,
        },
        texts: {
            display: 'flex',
            flexDirection: 'column',
            gap: remCalc(4),
            alignItems: 'flex-start',
            justifyContent: 'center',
        },
    },
    variants: {
        'top-right': {
            popover: {
                placement: 'top',
                arrowPadding: 3,
                offset: [120, 15],
                left: '-2px',
            },
            arrow: {
                left: '-2px !important',
            },
            container: {
                marginBottom: '0',
            },
        },
        'bottom-right': {
            popover: {
                placement: 'bottom',
                arrowPadding: 0,
                offset: [153, 15],
            },
        },
        'top-left': {
            popover: {
                placement: 'top',
                arrowPadding: 244,
                offset: [-118, 15],
            },
        },
        'top-left-no-y-offset': {
            popover: {
                placement: 'top',
                arrowPadding: 244,
                offset: [-105, 0],
            },
        },
        'bottom-left': {
            popover: {
                placement: 'bottom',
                arrowPadding: 244,
                offset: [-120, 15],
            },
        },
        'right-bottom': {
            popover: {
                placement: 'right',
                arrowPadding: 0,
                offset: [25, 6],
            },
        },
        'right-top': {
            popover: {
                placement: 'right',
                arrowPadding: 0,
                offset: [-25, 6],
            },
        },
        'left-bottom': {
            popover: {
                placement: 'left',
                arrowPadding: 0,
                offset: [-25, 6],
            },
        },
        'left-top': {
            popover: {
                placement: 'left',
                arrowPadding: 0,
                offset: [-25, 6],
            },
        },
        'right-center': {
            popover: {
                placement: 'right',
                arrowPadding: 0,
                offset: [0, 6],
            },
        },
        'left-center': {
            popover: {
                placement: 'left',
                arrowPadding: 0,
                offset: [0, 5],
            },
        },
        'more-information': {
            popover: {
                placement: 'bottom',
            },
        },
        'service-card': {
            popover: {
                placement: 'left',
            },
        },
    },
}
